// Types pour le Dashboard - API /api/v1/dashboard/summary

/**
 * Période de consultation du dashboard
 * Correspond à l'enum Period du backend: MONTH, QUARTER, YEAR
 */
export enum PeriodeDashboard {
  MOIS = 'MONTH',
  TRIMESTRE = 'QUARTER',
  ANNEE = 'YEAR',
}

/**
 * KPIs du dashboard (structure API backend)
 */
export interface DashboardKPIs {
  caEncaisse: number; // Chiffre d'affaires encaissé
  caFacture: number; // Chiffre d'affaires facturé
  montantEncours: number; // Montant en cours (impayés)
  nbDevisEnAttente: number; // Nombre de devis en attente
  tauxConversion: number; // Taux de conversion des devis
}

/**
 * Point de données pour le graphique cashflow
 */
export interface CashflowPoint {
  mois: string; // Format: "2025-02"
  reel: number; // Montant réel (factures payées)
  previsionnel: number; // Montant prévisionnel
}

/**
 * Facture impayée pour la hotlist
 */
export interface FactureImpayee {
  id: number;
  numeroFacture: string; // ex: "FAC-2025-042"
  clientNom: string;
  adresse: string;
  clientTelephone?: string; // Pour lien WhatsApp
  montantTTC: number;
  dateEcheance: string; // ISO format
  joursRetard: number; // Nombre de jours de retard
}

/**
 * Charge de travail
 */
export interface Workload {
  heuresVendues: number;
  capacite: number;
  tauxOccupation: number;
}

/**
 * Alertes TVA et Franchise
 */
export interface Alertes {
  montantTvaAProvisionner: number;
  progressionSeuilFranchise: number;
  caAnnuel: number;
  seuilFranchise: number;
}

/**
 * Réponse complète du dashboard
 */
export interface DashboardSummary {
  kpis: DashboardKPIs;
  cashflow: CashflowPoint[];
  hotlistImpayes: FactureImpayee[];
  workload: Workload;
  alertes: Alertes;
}
